import React, { useEffect, useState } from "react";
import { SpinnerWrapper } from "../../../components/styles";
import Spinner from "../../../../../utils/Spinner";
import { FibiUsersBillingData, FibiUsersBillingType } from "../data";
import FibiUsersBillingCard from "../FibiUsersBillingCard";
import {
  useFibiUsersSubscriptionPayment,
  useUserVerifyFibiPaystack,
} from "../../../../../hooks/utils/useUtils";
import useGetPrice from "../../../../../hooks/useGetPrice";
import { toast } from "react-toastify";
import { userDataStore } from "../../../../../store/userData";
import { useSnapshot } from "valtio";
import { PayStackParam } from "../../../form ds 160/components/types";
import { useSearchParams } from "react-router-dom";
import { BillingStripeQuery } from "../business/billing/components/data";
import StripeSuccessModal from "../StripeSuccessModal";
import { ChevronDown, ChevronUp } from "lucide-react";
import FiBiUsersContent from "../FiBiUsersContent";
import { usePaystackPayment } from "react-paystack";
import { PaystackProps } from "react-paystack/dist/types";

const FibiUsers = () => {
  const { userData } = useSnapshot(userDataStore);
  const initializePayment = usePaystackPayment({
    email: userData?.userInfo.email,
    publicKey: process.env.REACT_APP_PAYSTACK_API_KEY as string,
  });
  const { mutate: verifyMutate } = useUserVerifyFibiPaystack();
  const [openPlan, setOpenPlan] = useState(false);
  //   const { isBusinessData } = useSnapshot(isBusinessDataStore);
  //   const {
  //     data: businessUserData,
  //     isLoading: businessDataLoading,
  //     refetch,
  //   } = useGetBusinessProfile(isBusinessData);
  const { isNigeria } = useGetPrice();
  const [searchParams, setSearchParams] = useSearchParams();
  const { mutate: submutate, isLoading: subLoading } =
    useFibiUsersSubscriptionPayment();
  const billingTypeParams = searchParams.get(
    BillingStripeQuery.billingType
  ) as string;
  const paymentTypeParams =
    searchParams.get(BillingStripeQuery.paymentType) || "";

  useEffect(() => {
    const isActive = !!!userData?.userInfo.isFreeTrialActive;
    setOpenPlan(isActive);
  }, [userData?.userInfo.isFreeTrialActive]);

  //   const { mutate: upgradeMutate, isLoading: upgradeLoading } =
  //     useBusinessBillingUpgrade();
  //   const { mutate: downgradeMutate, isLoading: downgradeLoading } =
  //     useBusinessBillingDowngrade();
  //   const [upgradeOpen, setUpgradeOpen] = useState<BillingType>();
  //   const [downgradeOpen, setDowngradeOpen] = useState<BillingType>();

  //   const onUpgradeOpen = (second: BillingType) => {
  //     setUpgradeOpen(second);
  //   };

  //   const onUpgradeClose = () => {
  //     setUpgradeOpen(undefined);
  //   };

  //   const onDowngradeOpen = (second: BillingType) => {
  //     setDowngradeOpen(second);
  //   };

  //   const onDowngradeClose = () => {
  //     setDowngradeOpen(undefined);
  //   };

  //   const onUpgrade = () => {
  //     if (!upgradeOpen) return;

  //     const payload = {
  //       isNigeria,
  //       billingType: upgradeOpen,
  //     };

  //     upgradeMutate(payload, {
  //       onSuccess: () => {
  //         onUpgradeClose();
  //         refetch();
  //         toast.success("Upgrade Successful");
  //       },
  //     });
  //   };

  //   const onDowngrade = () => {
  //     if (!downgradeOpen) return;
  //     const payload = { email: [], isNigeria, billingType: downgradeOpen };

  //     downgradeMutate(payload, {
  //       onSuccess: () => {
  //         onDowngradeClose();
  //         refetch();
  //         toast.success("Downgrade Successful");
  //       },
  //     });
  //   };

  const onSubmit = (
    params: FibiUsersBillingType,
    price: number,
    paystackPlan: string
  ) => {
    if (params === FibiUsersBillingType.full) {
      toast.info("Plan not available at the moment");
      return;
    }

    if (isNigeria) {
      if (!userData?.userInfo.email) return;
      const config: Omit<PaystackProps, "publicKey"> = {
        email: userData?.userInfo.email,
        amount: price * 100,
        plan: paystackPlan,
      };
      initializePayment({
        config,
        onSuccess: () => {
          verifyMutate();
        },
      });
    } else {
      const payload = {
        billingType: params,
        isNigeria,
      };
      submutate(payload, {
        onSuccess: (data) => {
          window.location.replace(data.data.url);
        },
      });
    }
  };

  const onClick = (params: FibiUsersBillingType) => {
    // const isYearly = (plan: BillingType) =>
    //   plan.toLowerCase().includes("yearly");

    // const checkGrade = () => {
    //   if (!businessUserData?.paymentInfo.subscriptionType) return;

    //   const currentPlan = businessUserData.paymentInfo.subscriptionType;
    //   const requestedPlan = params;

    //   const currentRank = PlanRank[currentPlan];
    //   const requestedRank = PlanRank[requestedPlan];

    //   // If any plan is not ranked, exit early
    //   if (!currentRank || !requestedRank) return;

    //   if (currentRank === requestedRank) {
    //     // Same plan level: check for monthly vs yearly differences.
    //     if (isYearly(currentPlan) && !isYearly(requestedPlan)) {
    //       // Downgrading from yearly to monthly
    //       onDowngradeOpen(requestedPlan);
    //     } else if (!isYearly(currentPlan) && isYearly(requestedPlan)) {
    //       // Upgrading from monthly to yearly
    //       onUpgradeOpen(requestedPlan);
    //     }
    //     // If both share the same period type, nothing to do.
    //     return;
    //   }

    //   // For different ranks, a higher rank is an upgrade.
    //   if (requestedRank > currentRank) {
    //     onUpgradeOpen(requestedPlan);
    //   } else {
    //     onDowngradeOpen(requestedPlan);
    //   }
    // };
    // businessUserData?.paymentInfo.subscriptionType
    //   ? checkGrade()
    //   : onSubmit(params);

    const selectedPlan = FibiUsersBillingData.find((ev) => ev.id === params);
    const price = selectedPlan ? selectedPlan.price : 0;
    onSubmit(params, price, selectedPlan?.paystackPlan as string);
  };

  //   const masterLoading = subLoading || businessDataLoading;
  const masterLoading = subLoading;

  useEffect(() => {
    const trxrefParam = searchParams.get(PayStackParam.trxref);
    const referenceParam = searchParams.get(PayStackParam.reference);

    if (trxrefParam) {
      searchParams.delete(PayStackParam.trxref);
    }

    if (referenceParam) {
      searchParams.delete(PayStackParam.reference);
    }
    setSearchParams(searchParams);
  }, [searchParams, setSearchParams]);

  return (
    <>
      {/* <div className="flex flex-wrap items-center justify-between gap-6 mb-4">
        <Header>FiBi AI</Header>
      </div> */}

      <FiBiUsersContent />

      <div className="flex flex-col gap-4 p-6 border border-gray-100 rounded-xl">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <h5 className="text-lg font-medium text-[#0076E9]">Select Plan</h5>
          {openPlan ? (
            <ChevronUp
              className=" text-[#0076E9] cursor-pointer"
              onClick={() => setOpenPlan((prev) => !prev)}
            />
          ) : (
            <ChevronDown
              className=" text-[#0076E9] cursor-pointer"
              onClick={() => setOpenPlan((prev) => !prev)}
            />
          )}
        </div>

        {openPlan && (
          <>
            {masterLoading ? (
              <SpinnerWrapper>
                <Spinner size={40} />
              </SpinnerWrapper>
            ) : (
              <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 ">
                {FibiUsersBillingData.map((ev, index) => (
                  <FibiUsersBillingCard
                    key={index}
                    data={ev}
                    onButtonClick={onClick}
                    currentPlan={userData?.fibiSubInfo?.subscriptionType || ""}
                  />
                ))}
              </div>
            )}
          </>
        )}
      </div>

      {billingTypeParams && paymentTypeParams === "success" && (
        <StripeSuccessModal />
      )}
      {/* {downgradeOpen && (
        <TerminateModal
          title={`Downgrade Subscription`}
          subText={`Are you sure you want to downgrade your subscription?`}
          onClose={onDowngradeClose}
          onConfirm={onDowngrade}
          isLoading={downgradeLoading}
          confirmBg={Colors.Blue00}
        />
      )} */}

      {/* {upgradeOpen && (
        <TerminateModal
          title={`Upgrade Subscription`}
          subText={`Are you sure you want to upgrade your subscription?`}
          onClose={onUpgradeClose}
          onConfirm={onUpgrade}
          isLoading={upgradeLoading}
          confirmBg={Colors.Blue00}
        />
      )} */}
    </>
  );
};

export default FibiUsers;
